import { Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { TravelCardType } from '../../medium';
import { ValidationHistoryService } from '../validation-history.service';
import { ValidationHistoryActions } from './validation-history.actions';

@Injectable()
export class ValidationHistoryEpics implements RidangoEpic {
    constructor(private actions: ValidationHistoryActions, private service: ValidationHistoryService) {}

    register() {
        return [this.getValidationHistory];
    }

    getValidationHistory = (action$: ActionsObservable<any>) =>
        action$.ofType(ValidationHistoryActions.FETCH_VALIDATION_HISTORY).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { start, end, token } = action.payload;
                return this.service.fetchValidationHistory(start, end, token).pipe(
                    map((response) => this.actions.fetchValidationHistorySuccess(this.updateResponse(response))),
                    catchError((error) => of(this.actions.fetchValidationHistoryFail(error)))
                );
            })
        )

    private updateResponse(response: any) {
        return response.map((validation) => {
            validation.translations = validation.product_translations;
            validation.medium = validation.card_type === TravelCardType.Email ? validation.email : validation.card_id;
            return validation;
        });
    }
}
